import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'

import ListenToKeyboard from 'components/ListenToKeyboard'
import withMenuPositioning from 'shared/ui/Dropdown/withMenuPositioning'
import withOpenState from 'shared/ui/withOpenState'
import Menu from './Menu'

export default compose(withOpenState, withMenuPositioning)(LabelingDropdown)

LabelingDropdown.propTypes = {
  trigger: PropTypes.node.isRequired,
  hotKey: PropTypes.string,
}

LabelingDropdown.defaultProps = {
  hotKey: null,
}

function LabelingDropdown({
  bottom,
  left,
  hotKey, // e.g. 'onT'
  onOpen,
  open,
  right,
  top,
  trigger,
  ...rest
}) {
  const dynamicProps = hotKey ? { [hotKey]: onOpen } : {}

  return (
    <div onClick={!open ? onOpen : undefined}>
      {!open &&
        hotKey && (
          <ListenToKeyboard
            disableForInput
            preventDefault
            key="keyboard-listener"
            {...dynamicProps}
          />
        )}
      {trigger}
      <ListenToKeyboard hijack={open && ListenToKeyboard.DROPDOWN}>
        <Menu open={open} {...rest} offset={{ left, right, top, bottom }} />
      </ListenToKeyboard>
    </div>
  )
}
